exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[src=\"\"][data-v-16c6cbc0]{display:none}.voucher-print-container[data-v-16c6cbc0]{overflow-x:auto;-webkit-overflow-scrolling:touch}.voucher-print-container table[data-v-16c6cbc0]{min-width:600px}@media (max-width:600px){.voucher-print-container table[data-v-16c6cbc0]{font-size:11px}.voucher-print-container .subheading[data-v-16c6cbc0]{font-size:11px!important}.voucher-print-container .title[data-v-16c6cbc0]{font-size:14px!important}.project .layout[data-v-16c6cbc0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}", ""]);

// exports
